import { Controller } from "@hotwired/stimulus";
import Cookies from "js-cookie";

// Connects to data-controller="cookies"
export default class extends Controller {
	connect() {}
}
